// extracted by mini-css-extract-plugin
export default {"pageTitle":"Support_pageTitle__s3m5j","col":"Support_col__mS9BP"};